import { Avatar, Button, Drawer, Form, Select, Switch } from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import { getPage, jcTypeArray } from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import { EditOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import TopHeading from "./TopHeading";
import BannerDetails from "./BannerDetails";
import Empty from "../common/Empty";
import AddBanner from "./AddBanner";
import { responseNotification } from "../../utils/notify";
const { Option } = Select;

const BannerList = () => {
  const [status, setStatus] = useState("");
  const [type, setType] = useState("JC_MART");
  const [limit, setLimit] = useState(16);
  const [bannerData, setBannerData] = useState({
    loading: false,
    data: null,
  });
  const [selectedBanner, setSelectedBanner] = useState(undefined);
  const [selectedBannerForEdit, setSelectedBannerForEdit] = useState(undefined);
  const [visible, setVisible] = useState(undefined);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const [form] = Form.useForm();
  const loc = useLocation();

  const reseAllFieldData = () => {
    setStatus("");
    setType("JC_MART");
    form.resetFields();
  };

  // const handleChangeStatus = (value: string) => {
  //   setStatus(value);
  // };

  const getBanner = useCallback(async () => {
    setBannerData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    axios
      .get(
        `${encodedUri}/banner/by-status` +
          (type ? `?type=${type}` : ``) +
          (status ? `&deleted=${status}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setBannerData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setBannerData({ loading: false, data: [] });
        console.error("Banner: Error", err);
      });
  }, [status, type]);

  useEffect(() => {
    getBanner();
  }, [getBanner]);

  // const getbannerOptionsDebounce = (mobileNumber) => {
  //   const fetcher = (mobileNumber) => {
  //     getbannerOptions(mobileNumber);
  //   };

  //   return debounce(fetcher, 0.8);
  // };

  // const getbannerOptionsDebounce = React.useMemo(() => {
  //   const loadOptions = (value: string) => {
  //     fetchRef.current += 1;
  //     const fetchId = fetchRef.current;
  //     setBannerOptions({ loading: false, list: null });

  //     if (fetchId !== fetchRef.current) {
  //       return;
  //     }

  //     getbannerOptions(value);
  //   };

  //   return debounce(loadOptions, 800);
  // }, []);

  //
  const onDelete = async (id, val: any) => {
    if (id) {
      await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/banner`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
          deleted: !val,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            responseNotification("Status Updated Successfully", "success");
            getBanner();
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };
  //

  useEffect(() => {
    if (visible) {
      setSelectedBanner(undefined);
      setSelectedBannerForEdit(undefined);
    }
  }, [selectedBanner, selectedBannerForEdit, visible]);

  useEffect(() => {
    setSelectedBanner(undefined);
    setSelectedBannerForEdit(undefined);
  }, [visible]);

  const onClose = () => {
    setSelectedBanner(null);
    setSelectedBannerForEdit(null);
    getBanner();
  };
 
  return (
    <React.Fragment>
      <TopHeading {...bannerData?.data?.totalElements} refetch={getBanner} />
      <section className="search_area">
        <Form form={form} className="search_form">
          <Form.Item initialValue={type}>
            <Select
              placeholder="Type"
              onChange={(val) => setType(val)}
              value={type}
            >
              {Object.values(jcTypeArray)?.map((type, i) => (
                <Option value={type} key={i}>
                  {type?.replace("_", " ")}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item initialValue={null}>
            <Select
              placeholder="Status"
              onChange={(val) => setStatus(val)}
              value={status}
            >
              <Option value={""}>ALL</Option>
              <Option value={"false"}>ACTIVE</Option>
              <Option value={"true"}>INACTIVE</Option>
            </Select>
          </Form.Item>
        </Form>

        <div className="search_btn">
          <Button type="primary" danger size="large" onClick={reseAllFieldData}>
            Reset
          </Button>
        </div>
      </section>
      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading">
                    <span>Banner Name</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Type</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Status</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Action</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {bannerData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {bannerData?.data?.banners?.length ? (
                    bannerData?.data?.banners?.map(
                      (banner: any, index: any) => (
                        <React.Fragment key={index}>
                          <div
                            className="single-product-wrapper"
                            onClick={() => setSelectedBanner(banner)}
                          >
                            <div className="single-product">
                              <Avatar
                                shape="square"
                                size={45}
                                src={banner?.bannerImage}
                                className="mr-3"
                              />
                              <span className="name">{banner?.bannerName}</span>
                            </div>
                            <div className="single-product">
                              <span className="name">
                                {banner?.type?.replace("_", " ")}
                              </span>
                            </div>
                            <div className="single-product">
                              <Switch
                                checkedChildren={<CheckOutlined />}
                                unCheckedChildren={<CloseOutlined />}
                                defaultChecked={!banner?.deleted}
                                onChange={(val, e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  onDelete(banner?.id, val);
                                }}
                                loading={
                                  confirmLoading &&
                                  banner?.id === confirmLoading
                                }
                              />
                            </div>
                            <div className="single-product">
                              <button
                                className="btn btn-sm btn-warning mx-1"
                                onClick={() => setSelectedBannerForEdit(banner)}
                              >
                                <EditOutlined />
                              </button>
                            </div>
                          </div>
                        </React.Fragment>
                      )
                    )
                  ) : (
                    <Empty data="Banners" />
                  )}
                </div>
              </div>
            )}
          </div>

          <Drawer
            title={selectedBannerForEdit ? "Edit Banner" : "Banner Details"}
            width={500}
            onClose={onClose}
            visible={selectedBanner || selectedBannerForEdit}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              ></div>
            }
          >
            {selectedBannerForEdit ? (
              <AddBanner
                visibleData={selectedBannerForEdit}
                onCloseMethod={onClose}
              />
            ) : (
              <BannerDetails BannerDetails={selectedBanner} />
            )}
          </Drawer>

          <PaginationTwo
            {...bannerData?.data}
            limit={limit}
            page={getPage(loc.search)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default BannerList;
